import { render, staticRenderFns } from "./ZiyuanPinggu.vue?vue&type=template&id=21f66bb8&scoped=true&"
import script from "./ZiyuanPinggu.vue?vue&type=script&lang=js&"
export * from "./ZiyuanPinggu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f66bb8",
  null
  
)

export default component.exports